import React from 'react';
export default (function (props) {
  var color = props.color,
      size = props.size,
      className = props.className,
      style = props.style;
  color = color ? color : 'currentColor';
  size = size ? size : '100%';
  return /*#__PURE__*/React.createElement("svg", {
    style: style,
    className: className,
    width: size,
    height: size,
    fill: color,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19 19"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.5 15.833a6.333 6.333 0 1 0 0-12.666 6.333 6.333 0 0 0 0 12.666zm0-14.25a7.917 7.917 0 1 1 0 15.834c-4.378 0-7.917-3.563-7.917-7.917A7.917 7.917 0 0 1 9.5 1.583zm.396 3.959v4.156l3.562 2.114-.593.973-4.157-2.493v-4.75h1.188z"
  }));
});